
import AuthenticationService from './AuthenticationService';

export { default } from './AuthenticationService';
export const authenticationService = new AuthenticationService();
